import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import ButtonIcon from "../molecules/ButtonIcon.vue";
import ToolsBar from "../atoms/ToolsBar.vue";
import { useI18n } from "vue-i18n";
import { useConductor } from "@/utils/conductor";
import { useStore } from "vuex";
import { useAction } from "@/utils/vuex-hooks";
import { StoreData, Unlockable } from "@/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();

const { playRhodes, playClarinet, playSynth, playDrums, toggleWaveEffect } =
  useConductor();
const { state, getters } = useStore<StoreData>();
const playWith = useAction("playWith");

const onClickPiano = () => {
  playRhodes();
  playWith(Unlockable.rhodes);
};
const onClickViolin = () => {
  playSynth();
  playWith(Unlockable.synth);
};
const onClickFlute = () => {
  playClarinet();
  playWith(Unlockable.clarinet);
};
const onClickDrum = () => {
  playDrums();
  playWith(Unlockable.drum);
};
const onClickWater = () => {
  toggleWaveEffect();
  playWith(Unlockable.wave);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ToolsBar, null, {
    default: _withCtx(() => [
      (_unref(getters).isUnlocked(_unref(Unlockable).drum))
        ? (_openBlock(), _createBlock(ButtonIcon, {
            key: 0,
            highlight: _unref(getters).isNew(_unref(Unlockable).drum),
            name: "drum",
            size: "m",
            onClick: onClickDrum,
            "aria-label": _unref(t)('home.instruments.drum')
          }, null, 8, ["highlight", "aria-label"]))
        : _createCommentVNode("", true),
      (_unref(getters).isUnlocked(_unref(Unlockable).rhodes))
        ? (_openBlock(), _createBlock(ButtonIcon, {
            key: 1,
            highlight: _unref(getters).isNew(_unref(Unlockable).rhodes),
            name: "piano",
            size: "m",
            onClick: onClickPiano,
            "aria-label": _unref(t)('home.instruments.piano')
          }, null, 8, ["highlight", "aria-label"]))
        : _createCommentVNode("", true),
      (_unref(getters).isUnlocked(_unref(Unlockable).clarinet))
        ? (_openBlock(), _createBlock(ButtonIcon, {
            key: 2,
            highlight: _unref(getters).isNew(_unref(Unlockable).clarinet),
            name: "flute",
            size: "m",
            onClick: onClickFlute,
            "aria-label": _unref(t)('home.instruments.flute')
          }, null, 8, ["highlight", "aria-label"]))
        : _createCommentVNode("", true),
      (_unref(getters).isUnlocked(_unref(Unlockable).synth))
        ? (_openBlock(), _createBlock(ButtonIcon, {
            key: 3,
            highlight: _unref(getters).isNew(_unref(Unlockable).synth),
            name: "violin",
            size: "m",
            onClick: onClickViolin,
            "aria-label": _unref(t)('home.instruments.violin')
          }, null, 8, ["highlight", "aria-label"]))
        : _createCommentVNode("", true),
      (_unref(getters).isUnlocked(_unref(Unlockable).wave))
        ? (_openBlock(), _createBlock(ButtonIcon, {
            key: 4,
            highlight: _unref(getters).isNew(_unref(Unlockable).wave),
            name: "water",
            size: "m",
            onClick: onClickWater,
            active: _unref(state).wave,
            role: "switch",
            "aria-checked": _unref(state).wave,
            "aria-label": _unref(t)('home.instruments.wave')
          }, null, 8, ["highlight", "active", "aria-checked", "aria-label"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})